/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PluginDriftEvent interface.
 */
export function instanceOfPluginDriftEvent(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('firstSeen' in value) || value['firstSeen'] === undefined)
        return false;
    if (!('lastSeen' in value) || value['lastSeen'] === undefined)
        return false;
    if (!('pluginVersion' in value) || value['pluginVersion'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    if (!('slot' in value) || value['slot'] === undefined)
        return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined)
        return false;
    if (!('uniqueInstalls60Min' in value) || value['uniqueInstalls60Min'] === undefined)
        return false;
    return true;
}
export function PluginDriftEventFromJSON(json) {
    return PluginDriftEventFromJSONTyped(json, false);
}
export function PluginDriftEventFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'alert15MinSentAt': json['alert15MinSentAt'] == null ? undefined : (new Date(json['alert15MinSentAt'])),
        'alert60MinSentAt': json['alert60MinSentAt'] == null ? undefined : (new Date(json['alert60MinSentAt'])),
        'date': json['date'],
        'firstSeen': (new Date(json['firstSeen'])),
        'lastSeen': (new Date(json['lastSeen'])),
        'pluginVersion': json['pluginVersion'],
        'provider': json['provider'],
        'slot': json['slot'],
        'totalCount': json['totalCount'],
        'uniqueInstalls60Min': json['uniqueInstalls60Min'],
    };
}
export function PluginDriftEventToJSON(json) {
    return PluginDriftEventToJSONTyped(json, false);
}
export function PluginDriftEventToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'alert15MinSentAt': value['alert15MinSentAt'] == null ? value['alert15MinSentAt'] : value['alert15MinSentAt'].toISOString(),
        'alert60MinSentAt': value['alert60MinSentAt'] == null ? value['alert60MinSentAt'] : value['alert60MinSentAt'].toISOString(),
        'date': value['date'],
        'firstSeen': value['firstSeen'].toISOString(),
        'lastSeen': value['lastSeen'].toISOString(),
        'pluginVersion': value['pluginVersion'],
        'provider': value['provider'],
        'slot': value['slot'],
        'totalCount': value['totalCount'],
        'uniqueInstalls60Min': value['uniqueInstalls60Min'],
    };
}
